export default {
  // Gets all users
      users: [
      {
        userId: 1,
        image:"https://picsum.photos/200",
        name: {first:"Kris", last:"Jacobs"},
        phone: "5122222222",
        email: "krish.lee&#64;learningcontainer.com",
        dob:"05-23-1987"
      },
      {
        userId: 2,
        image:"https://picsum.photos/199",
        name: {first:"Lucas", last:"Morris"},
        phone: "123456",
        email: "racks.jacson&#64;learningcontainer.com",
        dob: "07-23-1990"

      },
      {
        userId: 3,
        image:"https://picsum.photos/198",
        name: {first:"Sandy", last:"Ruedell"},
        phone: "2354430",
        email: "joe.jacson@learningcontainer.com",
        dob: "07-23-2000"

      }
    ]
  }